import classificationsShader from "./viewer/textures/colormaps/classifications.png";

export interface Classification {
  id: number;
  name: string;
  alias: Array<[]>;
}

const numberOfDefinedClassifications = 19;
export const numberOfClassifications = 256;

export const classifications = [
  {
    id: 0,
    name: "Never Classified",
    alias: ["never classified", "unclassified"]
  },
  {
    id: 1,
    name: "Unassigned",
    alias: ["unassigned"]
  },
  {
    id: 2,
    name: "Ground",
    alias: ['ground', 'dtm', 'base', 'earth', 'dirt', 'land', 'd.t.m'],
  },
  {
    id: 3,
    name: "Low Vegetation",
    alias: ['low_vegetation','low vegetation', 'low_veg', 'low veg', 'lo veg','lo_veg'],

  },
  {
    id: 4,
    name: "Medium Vegetation",
    alias: ['vegetation', 'tree', 'trees', 'bushes', 'lawn', 'forest', 'garden',
      'gardens', 'arbor', 'flora', 'crops', 'crop', 'green', 'greenery',
      'medium_vegetation', 'medium vegetation', 'med_veg', 'med veg', 'medium veg',
      'medium_veg']
  },
  {
    id: 5,
    name: "High Vegetation",
    alias: ['high_vegetation', 'high vegetation', 'high_veg', 'high veg', 'hi veg',
      'hi veg', 'canopy']
  },
  {
    id: 6,
    name: "Building",
    alias: ['building', 'buildings', 'structures', 'built']
  },
  {
    id: 7,
    name: "Noise",
    alias: ['noise', 'errors', 'multipass']
  },
  {
    id: 8,
    name: 'Model Key/Reserved',
    alias: ['lightpole', 'light pole', 'pole', 'power pole', 'powerpole', 'lightpoles',
      'light poles', 'light_poles', 'power_pole', 'power_poles', 'model key', 'reserved']
  },
  {
    id: 9,
    name: "Water",
    alias: ['water', 'river', 'stream', 'sea', 'ocean', 'lake', 'bay','lagoon','lakes',
      'rivers', 'streams', 'lagoons', 'waterway', 'waterways']
  },
  {
    id: 10,
    name: "Rail",
    alias: ['rail', 'railroad', 'rail road', 'train', 'trains', 'rail-road', 'rail_road',
      'railway', 'railways', 'railroads']
  },
  {
    id: 11,
    name: "Road Surface",
    alias: ['road', 'roads', 'streets', 'highway', 'highways', 'avenues', 'pavement',
      'road surface', 'road_surface', 'road surfaces', 'road_surfaces']
  },
  {
    id: 12,
    name: 'Overlap/Reserved',
    alias: ['overlap', 'overlap reserved', 'overlap_reserved']
  },
  {
    id: 13,
    name: "Wire - Guard",
    alias: ['wire guard', 'wire-guard', 'wires - guard', 'wire_guard']
  },
  {
    id: 14,
    name: "Wire - Conductor",
    alias: ['wire conductor', 'wire-conductor', 'wires - conductor', 'wire_conductor']
  },
  {
    id: 15,
    name: "Transmission Tower",
    alias: ['transmission tower', 'transmission-tower', 'transmission_tower']
  },
  {
    id: 16,
    name: "Wire - Connector",
    alias: ['powerlines', 'power lines', 'powerline', 'power line', 'power_lines',
      'power_line', 'wire', 'wires', 'connectors', 'wire_connector', 'wire connector',
      'wire_connectors', 'wire connectors']
  },
  {
    id: 17,
    name: "Bridge Deck",
    alias: ['bridge', 'bridge deck', 'bridge-deck', 'bridge_deck', 'bridges', 'overpass',
      'overpasses', 'fly over', 'fly-over', 'fly_over']
  },
  {
    id: 18,
    name: "High Noise",
    alias: ['high noise', 'high_noise', 'high-noise', 'highnoise']
  },
  ...Array.from(Array(numberOfClassifications - numberOfDefinedClassifications).keys()).map(key => ({id: key + numberOfDefinedClassifications, name: 'Reserved', alias:[]}))
];

export const getClassificationColors = (): Promise<string[]> => {
  return new Promise(resolve => {
    const image = new Image();

    image.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = image.width;
      canvas.height = image.height;

      const context = canvas.getContext('2d');
      context.drawImage(image, 0, 0);

      const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
      let colors = [];

      for (let i = 0; i < classifications.length; i++) {
        let index = i * 4;

        let red = imageData.data[index] << 16;
        let green = imageData.data[index + 1] << 8;
        let blue = imageData.data[index + 2];

        const hexColor = `#${(red + blue + green).toString(16).padStart(6, '0')}`;
        colors.push(hexColor);
      }

      resolve(colors);
    };

    image.src = classificationsShader;
  });
};